import { render } from "./BuyHomeComponent.vue?vue&type=template&id=2bf3ed00&ts=true"
import script from "./BuyHomeComponent?vue&type=script&lang=ts"
export * from "./BuyHomeComponent?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/atlantis/atlantis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__